import { emailValidation, phoneValidation, fieldLevelValidation, requiredFieldsValidation } from 'utils/form';
import { leftTrimProps } from 'utils/form';

const rules = {
	email: emailValidation,
	phone: phoneValidation,
};

function validate(values, props) {
	const errors = {};

	leftTrimProps(values);
	requiredFieldsValidation(values, props.config, errors);
	fieldLevelValidation(values, rules, errors);

	return errors;
}

export default validate;
